import * as React from 'react';
import { themr } from 'react-css-themr';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import classnames from 'classnames';
import theme from './VerifyButton.scss';
import Icon from 'common/components/core/icon';
import { Loader } from 'common/components/core/loader/Loader';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
import { translate } from 'react-i18next';

class VerifyButton extends React.PureComponent {
    render() {
        const {
            theme,
            disabled,
            nonEditable,
            onVerify,
            isVerified,
            isVerifyInProgress,
            verifyError,
            popOver,
            noLabel,
            t,
            testId
        } = this.props;
        const verifyBtnLabel = (
            <div className={theme.buttonLabelWrap}>
                <div className={theme.checkbox}>
                    <Icon
                        icon="tickmark"
                        theme={theme}
                        className={theme.tickIcon}
                    />
                    {isVerifyInProgress ? (
                        <Loader theme={theme} active />
                    ) : null}
                </div>
                {!noLabel ? (
                    <div className={theme.checkboxLabel}>
                        {isVerified
                            ? t(
                                  'locationTable.verificationButtonStates.verified'
                              )
                            : t(
                                  'locationTable.verificationButtonStates.unverified'
                              )}
                    </div>
                ) : null}
            </div>
        );
        const popOverContent = popOver ? popOver : verifyError;
        const isDisabled = disabled || isVerifyInProgress;
        return (
            <ButtonWithPopover
                testId={testId}
                theme={theme}
                onClick={!nonEditable && onVerify}
                label={verifyBtnLabel}
                ripple={false}
                buttonType={ButtonTypes.Link}
                className={classnames(theme.verifyBtn, {
                    [theme.isVerified]: isVerified && !isVerifyInProgress,
                    [theme.isVerifyInProgress]: isVerifyInProgress,
                    [theme.isNonEditable]: nonEditable
                })}
                disabled={isDisabled}
                popOverContent={popOverContent}
                isPopOverOpen={!!verifyError}
                triggerPopoverOn={PopoverTriggerEnum.Hover}
            />
        );
    }
}

const ThemedVerifyButton = themr(
    'VerifyButton',
    theme
)(translate('entityManagement')(VerifyButton));
export { ThemedVerifyButton as VerifyButton };
export default ThemedVerifyButton;
